import useCachedDataFetcher from '~/components/hooks/useCachedDataFetcher';

import type { ClaimFieldsConfigurationsResponse } from '../types';

type ReloadFieldsConfigurations = () => Promise<ClaimFieldsConfigurationsResponse | undefined>;

type MaybeFieldsConfigurations = ClaimFieldsConfigurationsResponse['fields_configurations'] | null;

interface UseFetchClaimFieldsConfigurationsArgs {
  organizationId: number;
  shouldFetch: boolean;
}

interface UseFetchClaimFieldsConfigurationsReturnType {
  fieldsConfigurations: MaybeFieldsConfigurations;
  isLoading: boolean;
  isError: boolean;
  reloadData: ReloadFieldsConfigurations;
}

const buildCacheKey = (organizationId: number): string => {
  return `claim-fields-configuration:${organizationId}`;
};

const useFetchClaimFieldsConfigurations = ({
  organizationId,
  shouldFetch = true,
}: UseFetchClaimFieldsConfigurationsArgs): UseFetchClaimFieldsConfigurationsReturnType => {
  const { data, isLoading, isError, reloadData } = useCachedDataFetcher<ClaimFieldsConfigurationsResponse>({
    url: `/api/v1/organizations/${organizationId}/claim_fields_configuration`,
    shouldUseCache: true,
    localCacheKey: buildCacheKey(organizationId),
    shouldFetch,
  });

  const fieldsConfigurations = data?.fields_configurations || null;

  return { fieldsConfigurations, isLoading, isError, reloadData };
};

export default useFetchClaimFieldsConfigurations;
